import React, { createContext, useCallback, useState, useMemo } from "react";

const SearchContext = createContext();

const SearchContextProvider = ({ children }) => {
  const [searchedItem, setSearchedItem] = useState({});
  const [searchType, setSearchType] = useState("ویدئو");

  const updateSearchedItem = useCallback((newData) => {
    setSearchedItem(newData);
  }, []);

  const contextValue = useMemo(
    () => ({
      searchedItem,
      updateSearchedItem,
      searchType,
      setSearchType,
    }),
    [searchedItem, updateSearchedItem, searchType, setSearchType]
  );

  return (
    <SearchContext.Provider value={contextValue}>
      {children}
    </SearchContext.Provider>
  );
};

export { SearchContext, SearchContextProvider };
